/**
 * One identity, more than one company. Shared by the login-time tenant choice and the
 * "Switch account" menu so both show a tenant's own uploaded logo the same way — falling
 * back to the tinted initial mark, the same fallback the topbar itself uses, when a tenant
 * has not uploaded one.
 *
 * `current`, when passed, renders as a non-interactive row above the pickable list — the
 * switch-account menu is a "where am I, and where else could I go" question, not just the
 * second half of it, so which company is live right now is never left to be inferred.
 */
export default function TenantPicker({ tenants, onPick, busy, current }) {
  return (
    <div className="tenant-picker">
      {current && (
        <div className="tenant-pick tenant-pick-current">
          {current.logoPath ? (
            <img className="tenant-pick-logo" src={`/uploads/${current.logoPath}`} alt="" />
          ) : (
            <span className="tenant-pick-mark">{(current.name || '?').slice(0, 1).toUpperCase()}</span>
          )}
          <span>{current.name}</span>
          <span className="tag muted" style={{ marginLeft: 'auto' }}>Current</span>
        </div>
      )}
      {tenants.map((t) => (
        <button
          key={t.id}
          type="button"
          className="btn tenant-pick"
          disabled={busy}
          onClick={() => onPick(t.id)}
        >
          {t.logoPath ? (
            <img className="tenant-pick-logo" src={`/uploads/${t.logoPath}`} alt="" />
          ) : (
            <span className="tenant-pick-mark">{(t.name || '?').slice(0, 1).toUpperCase()}</span>
          )}
          <span>{t.name}</span>
        </button>
      ))}
    </div>
  )
}
